const PaymentAction = {
  GET_TOKEN_LOADING: 'GET_TOKEN_LOADING',
  GET_TOKEN_LOADED: 'GET_TOKEN_LOADED',
  PAYMENT_SUCCESS: 'PAYMENT_SUCCESS',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  RESET_TRANSACTION: 'RESET_TRANSACTION',
  SUBMIT_TRANSACTION: 'SUBMIT_TRANSACTION',
};

export default PaymentAction;
